import React, { useContext, useState, useEffect } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import Loaders from '@/product/components/molecules/Loaders'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import settingContext from '@/custom/context/setting/settingContext'

const AuditTrialListing = (props) => {
    const SettingContext = useContext(settingContext)

    const { audit_trial_data, fetchAuditTrailDetails } = SettingContext

    const [isLoading, setIsLoading] = useState(true)

    const [tableBody, setTableBody] = useState([])
    let initialValue = {
        page: 1,
        limit: 20,
        filters: {
            pid: {
                value: props.match.params.id,
                type: 'in',
                field: 'pat.project_id',
            },
        },
    }

    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: (values) => {
            setIsLoading(true)
            fetchAuditTrailDetails(values)
        },
    })

    const tableValues = []

    tableValues.push(
        {
            field: 'action_name',
            type: '',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Action',
        },
        {
            field: 'description',
            type: '',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Description',
            disableTooltip: true,
            tooltipFormat: 'number',
            type: 'tooltip',
        },

        {
            field: 'email',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User Email',
        },
        {
            field: 'username',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User Name',
        },
        // {
        //     field: 'first_name',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'User FirstName',
        // },
        // {
        //     field: 'last_name',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'User LastName',
        // },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Auditated On',
        }
    )

    useEffect(() => {
        if (props?.match?.params?.id) {
            fetchAuditTrailDetails({
                page: 1,
                limit: 20,
                filters: {
                    projectId: {
                        value: props.match.params.id,
                        type: 'in',
                        field: 'pat.project_id',
                    },
                },
            })
        }
    }, [props.match.params.id])

    useEffect(() => {
        if (audit_trial_data?.records?.length > 0) {
            setTableBody(audit_trial_data.records)
            setIsLoading(false)
        } else {
            setTableBody([])
            setIsLoading(false)
        }
    }, [audit_trial_data])

    return (
        <>
            {' '}
            <Layout>
                <div className="dashboard listing">
                    {isLoading ? (
                        <Loaders name="table" isLoading={isLoading} />
                    ) : (
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={audit_trial_data}
                            changeTableFunction={fetchAuditTrailDetails}
                        />
                    )}
                </div>
            </Layout>
        </>
    )
}

export default AuditTrialListing
